import getPayoffQuoteFetcher from './payoffQuoteFetcher.js';
import getPath from '../../fetchers/utils/getPath.js';
class PayoffQuoteService {
  constructor(_ref) {
    let {
      environment
    } = _ref;
    this.lenders = [];
    this.selectedLender = null;
    this.fetcher = getPayoffQuoteFetcher(getPath(environment));
  }
  async getAllLenders() {
    // clear selected lender
    this.selectedLender = null;

    // get all lenders
    const allLenders = await this.fetcher.fetchAllPartners();
    this.lenders = allLenders;
    return [...this.lenders];
  }
  async getSearchOptionsByLenderName(_ref2) {
    let {
      name
    } = _ref2;
    const selectedLender = this.lenders.filter(lender => lender?.name === name)?.[0];
    if (selectedLender?.partnerId) {
      this.selectedLender = {
        partnerId: selectedLender.partnerId
      };
      const response = await this.fetcher.fetchPartnerById(selectedLender?.partnerId);
      if (Object.keys(response || {}).length > 0) {
        this.selectedLender.searchOptions = response;
        return {
          selectedLender,
          data: response
        };
      }
    }
    return {
      error: true,
      selectedLender
    };
  }
  async submitPayoffQuote(_ref3) {
    let {
      isLeased,
      vin,
      accountNumber,
      customerLastName,
      postalCode,
      ssnLastFour,
      searchMethod,
      ...rest
    } = _ref3;
    if (this.selectedLender) {
      const payload = {
        partnerId: this.selectedLender.partnerId,
        financeMethod: isLeased ? 'Lease' : 'Retail',
        searchKey: searchMethod,
        searchValue: searchMethod === 'VIN' ? vin : accountNumber,
        ...(customerLastName !== '' && {
          customerLastName
        }),
        ...(postalCode !== '' && {
          postalCode
        }),
        ...(ssnLastFour !== '' && {
          ssnLastFour
        }),
        ...rest
      };
      const payoffQuote = await this.fetcher.fetchPayoffQuote(payload);
      return payoffQuote;
    }
    return {
      error: true,
      message: 'Selected Lender does not exist'
    };
  }
}
export { PayoffQuoteService as default };
